import * as React from "react";
import { cx } from "../util.js";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Elevation. @default "sm" */
  elevation?: "flat" | "sm" | "md";
  /** Adds hover lift + pointer for clickable cards. */
  interactive?: boolean;
}
/** Surface container. */
export function Card({ elevation = "sm", interactive, className, ...rest }: CardProps) {
  return (
    <div
      className={cx("ip-card", className)}
      data-elevation={elevation === "sm" ? undefined : elevation}
      data-interactive={interactive ? "true" : undefined}
      {...rest}
    />
  );
}

export interface CardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {}
export function CardHeader({ className, ...rest }: CardHeaderProps) {
  return <div className={cx("ip-card-header", className)} {...rest} />;
}

export interface CardBodyProps extends React.HTMLAttributes<HTMLDivElement> {}
export function CardBody({ className, ...rest }: CardBodyProps) {
  return <div className={cx("ip-card-body", className)} {...rest} />;
}
